import DisplayFieldDateRange from '@shared/components/displays/display-field-date-range/display-field-date-range.vue';
import DisplayFieldDate from '@shared/components/displays/display-field-date/display-field-date.vue';
import DisplayFieldTimeRange from '@shared/components/displays/display-field-time-range/display-field-time-range.vue';
import DisplayFieldTime from '@shared/components/displays/display-field-time/display-field-time.vue';
import { ActivityLog } from '@tools/interfaces/activity-log';
import { get } from 'lodash';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'bpc-activity-booking-short-info',
  components: {
    'bps-display-field-date-range': DisplayFieldDateRange,
    'bps-display-field-time-range': DisplayFieldTimeRange,
    'bps-display-field-time': DisplayFieldTime,
    'bps-display-field-date': DisplayFieldDate,
  },
})
export default class ActivityBookingShortInfo extends Vue {
  @Prop(Object) readonly item: ActivityLog;

  get bookingEvent(): boolean {
    return this.item.subject_type_name === 'booking_event';
  }

  get eventDate(): string {
    return get(this.item, 'subject.date', get(this.item, 'properties.attributes.date', null));
  }

  get eventStartTime(): string {
    return get(
      this.item,
      'subject.start_time',
      get(this.item, 'properties.attributes.start_time', null),
    );
  }

  get eventEndTime(): string {
    return get(
      this.item,
      'subject.end_time',
      get(this.item, 'properties.attributes.end_time', null),
    );
  }

  get eventTimeRange(): object {
    return { start_time: this.eventStartTime, end_time: this.eventEndTime };
  }

  get startDate(): string {
    return get(
      this.item,
      'subject.start_date',
      get(this.item, 'properties.attributes.start_date', null),
    );
  }
  get endDate(): string {
    return get(
      this.item,
      'subject.end_date',
      get(this.item, 'properties.attributes.end_date', null),
    );
  }

  get dateRange(): object {
    return get(this.item, 'subject.date_range', {
      start_date: this.startDate,
      end_date: this.endDate,
    });
  }

  get startTime(): string {
    return get(
      this.item,
      'subject.start_time',
      get(this.item, 'properties.attributes.start_time', null),
    );
  }
  get endTime(): string {
    return get(
      this.item,
      'subject.end_time',
      get(this.item, 'properties.attributes.end_time', null),
    );
  }

  get timeRange(): object {
    return get(this.item, 'subject.time_range', {
      start_time: this.startTime,
      end_time: this.endTime,
    });
  }

  get repetitive(): boolean {
    return !!get(this.item, 'subject.repetitive', false);
  }

  get code(): string {
    return get(this.item, 'subject.code', null);
  }

  get name(): string {
    return get(this.item, 'subject.name', null);
  }

  get type(): string {
    return get(this.item, 'subject_type_name', null);
  }
}
